import moment from "moment";

export function GenerateSocialSecurityNumber(project) {
  if (!project || !project.contact || !project.contact.user) {
    console.warn("Missing required project data");
    return null;
  }

  const genderCode = project.contact.user.gender === "F" ? "2" : "1";

  const birthDate = moment(project.contact.user.birthDate);
  const year = birthDate.format("YY");
  const month = birthDate.format("MM");

  return `${genderCode}${year}${month}`;
}
